import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';

export const Intro = styled.div`
  text-align: ${({ contentAlignment }) => contentAlignment || 'left'};
  margin: 0 1.5rem 0.75rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: unset;
    margin-bottom: 3rem;
  }
`;

export const Header = styled.h2`
  margin-bottom: 1.5rem;
`;

export const CalculatorWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    border-radius: 1.25rem;
    border: 1px solid ${themeGet('colors.border-grey')};
  }
`;

export const Calculator = styled.div`
  width: 100%;
  background-color: ${themeGet('colors.white')};
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 55%;
    border-radius: 1.25rem 0 0 1.25rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 65%;
    border-radius: 1.25rem 0 0 1.25rem;
  }
`;

export const Results = styled.div`
  width: 100%;
  background-color: #fcfcfd;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    border-radius: 0 1.25rem 1.25rem 0;
    border-left: 1px solid ${themeGet('colors.border-grey')};
    width: 45%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 35%;
  }
`;

export const Button = styled.button`
  display: flex;
  flex-direction: row;
  margin: auto 1.15rem;
  height: 5.25rem;
  align-items: center;

  p {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.5rem;
    margin: auto;
  }

  &.active {
    border-bottom: 1px solid ${themeGet('colors.secondary-velvet')};
    p {
      color: ${themeGet('colors.secondary-velvet')};
    }
  }
`;

export const ButtonContainer = styled.div`
  display: grid;
  position: relative;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  margin-left: 2rem;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    margin-left: 3rem;
  }

  button:first-child {
    &::after {
      content: '';
      position: absolute;
      right: 50%;
      top: calc(50% - 0.625rem);
      width: 1px;
      height: 1.25rem;
      border-right: 1px solid ${themeGet('colors.main-text')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: auto 1.6rem;
  }
`;

export const CalculatorHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 5.25rem;
  border-bottom: 1px solid ${themeGet('colors.border-grey')};
`;

export const CalculatorTitle = styled.div`
  display: none;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: block;
    margin: auto 2.75rem;
  }
`;
